export default __webpack_public_path__ + "../img/a6ddf37739b0b3a5597e3d50614b4bd6.png";